import axios from "axios";
import { routeToServerlessAPI } from "./errorHandler";

export const GetConnectionStatus = async (token, userId) => {
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const params = {
        uid: userId
    };
    let urlPath = '/algo/demo/data/status';
    if (userId) {
        try {
            let status;
            if (!routeToServerlessAPI()) {
                try {
                    status = await axios.get(
                        `${process.env.REACT_APP_API_URL}${urlPath}`,
                        {
                            headers: headers,
                            params: params,
                        }
                    )
                } catch (error) {
                    if (routeToServerlessAPI(error)) {
                        urlPath = '/api/v2/data/status';
                        status = await axios.get(
                            `${process.env.REACT_APP_SERVERLESS_API_URL}${urlPath}`,
                            {
                                headers: headers,
                                params: params,
                            }
                        )
                    } else {
                        throw new Error(error);
                    }
                }
            } else {
                urlPath = '/api/v2/data/status';
                status = await axios.get(
                    `${process.env.REACT_APP_SERVERLESS_API_URL}${urlPath}`,
                    {
                        headers: headers,
                        params: params,
                    }
                )
            }

            return status;
        } catch (error) {
            console.log(error.message);
            return error.message;
        }
    }
};